<script lang="ts">
  import type { Snippet } from 'svelte'

  interface Props {
    variant?: 'primary' | 'secondary' | 'ghost' | 'danger'
    size?: 'md' | 'lg'
    type?: 'button' | 'submit'
    disabled?: boolean
    full?: boolean
    title?: string
    onclick?: (event: MouseEvent) => void
    children: Snippet
  }
  const {
    variant = 'secondary',
    size = 'md',
    type = 'button',
    disabled = false,
    full = false,
    title,
    onclick,
    children,
  }: Props = $props()
</script>

<button class="btn {variant} {size}" class:full {type} {disabled} {title} {onclick}>
  {@render children()}
</button>

<style>
  .btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: var(--space-2);
    min-height: 44px;
    padding: 0 var(--space-4);
    border: 1px solid transparent;
    border-radius: var(--radius);
    background: var(--surface-2);
    color: var(--fg);
    font-weight: 550;
    transition: background var(--dur-fast) var(--ease), border-color var(--dur-fast) var(--ease);
  }
  .btn:hover:not(:disabled) {
    background: color-mix(in srgb, var(--surface-2) 85%, var(--fg) 15%);
  }
  .btn:disabled {
    opacity: 0.55;
    cursor: not-allowed;
  }
  .primary {
    background: var(--accent);
    color: var(--accent-fg);
  }
  .primary:hover:not(:disabled) {
    background: color-mix(in srgb, var(--accent) 88%, black 12%);
  }
  .secondary {
    border-color: var(--border);
    background: var(--surface);
  }
  .ghost {
    background: transparent;
  }
  .ghost:hover:not(:disabled) {
    background: var(--surface-2);
  }
  .danger {
    background: var(--danger-soft);
    color: var(--danger);
  }
  .lg {
    min-height: 52px;
    font-size: 17px;
  }
  .full {
    width: 100%;
  }
</style>
